import { CustomerSupportState } from '../states/customer-support.state';
import { CustomerSupportActionTypes, CustomerSupportAction } from '../actions/customer-support.actions';
/** CustomerSupportReducer */
export function CustomerSupportReducer (state: CustomerSupportState, action: CustomerSupportAction): CustomerSupportState {

    switch (action.type) {
        case CustomerSupportActionTypes.STORE_HOTLINE_NUMBER:
            return { ...state, hotLineNumber: action.payload.hotlineNumber };
        case CustomerSupportActionTypes.STORE_CUSTOMER_SUPPORT_MESSAGES:
            return {
                ...state, smsMessage: action.payload.smsMessage,
                whatsappMessage: action.payload.whatsappMessage,
            };
        case CustomerSupportActionTypes.STORE_CALLBACK_LINK_IDENTIFER:
            return { ...state, thema: action.payload.thema, icmp: action.payload.icmp };
        default:
            return state;
    }
}
